'use client';

import {
  QueryClientProvider as TanStackQueryClientProvider,
  type QueryClientProviderProps,
} from '@tanstack/react-query';
import dynamic from 'next/dynamic';
import { useState } from 'react';
import { queryClient } from './query-client';

// Only loaded in development — excluded from production bundle via dead code elimination
const ReactQueryDevtools =
  process.env.NODE_ENV === 'development'
    ? dynamic(() =>
        import('@tanstack/react-query-devtools').then((m) => ({
          default: m.ReactQueryDevtools,
        }))
      )
    : () => null;

export function QueryClientProvider({
  children,
}: Omit<QueryClientProviderProps, 'client'>) {
  const [queryClientState] = useState(() => queryClient);

  return (
    <TanStackQueryClientProvider client={queryClientState}>
      {children}
      <ReactQueryDevtools initialIsOpen={false} />
    </TanStackQueryClientProvider>
  );
}
